
import { supabase } from "@/integrations/supabase/client";

export const sendEmailNotification = async (
  requestType: string, 
  additionalInfo?: Record<string, any>,
  userEmail?: string
) => {
  try {
    console.log(`Sending email notification for: ${requestType}`, { additionalInfo, userEmail });
    
    const { data, error } = await supabase.functions.invoke('send-notification', {
      body: { 
        requestType, 
        additionalInfo,
        userEmail,
        to: 'cking@del-phi.com'
      }
    });
    
    if (error) {
      console.error("Supabase function error:", error);
      throw error;
    }
    
    console.log('Email notification sent:', data);
    return {
      success: true,
      message: "Request sent successfully"
    };
  } catch (error) {
    console.error("Error sending email notification:", error);
    throw error;
  }
};
